module.exports = "<li uib-dropdown on-toggle=\"vm.toggled(open)\" class=\"st-navbar__menu__item\">\n\n    <a uib-dropdown-toggle class=\"st-navbar__menu__link\" href=\"#\">{{vm.language.key}}<span class=\"st-icon-chevron-down  st-icon-chevron-down-sm-button\"></span></a>\n    <ul uib-dropdown-menu class=\"st-navbar__dropdown\">\n        <li ng-repeat=\"(key, language) in vm.languages\">\n            <a href ng-click=\"vm.fetchLanguage(key)\"> {{language.label}} </a>\n        </li>\n    </ul>\n</li>"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/languageSelector/languageSelector.html
// module id = 33
// module chunks = 0